/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import PropTypes from 'prop-types'; // eslint-disable-line no-unused-vars
import BSTable from 'react-bootstrap/Table';

import styles from './SimpleTable.module.scss';

SimpleTable.propTypes = {
    header: PropTypes.element,
    children: PropTypes.node,
    verticalAlignTop: PropTypes.bool,
    className: PropTypes.string,
};

export default function SimpleTable(props) {
    return (
        <BSTable
            className={`${styles['motili-simple-table']} ${[props.className]}`}
            id='motili-simple-table'
        >
            {props.header}
            <tbody
                className={`${styles.body} ${
                    props.verticalAlignTop && styles.verticalAlignTop
                }`}
            >
                {props.children}
            </tbody>
        </BSTable>
    );
}

SimpleTableHeader.propTypes = {
    children: PropTypes.node,
    noBottomBorder: PropTypes.bool,
    fixedHeader: PropTypes.bool,
};

export function SimpleTableHeader({
    noBottomBorder = true,
    fixedHeader = false,
    children,
}) {
    return (
        <thead>
            <tr
                className={`${styles.header} ${
                    noBottomBorder ? styles['no-bottom-border'] : ''
                } ${fixedHeader ? styles['table-fixed-header'] : ''}`}
            >
                {children}
            </tr>
        </thead>
    );
}
